<nav class="rail" aria-label="Application switcher">
  <!-- Scrollable menu wrapped in scroll-zone for gradient hint overlays -->
  <div class="rail__scroll-zone">
    <button
      class="rail__fade rail__fade--up"
      [class.rail__fade--visible]="canScrollUp"
      (click)="scrollUp()"
      aria-label="Scroll up"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M5 15l7-7 7 7"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div #menuViewport class="rail__menu">
      <div class="rail__section rail__section--main">
        @for (app of builtInApps; track app.id) {
          <ec-rail-item [app]="app" />
        }
      </div>

      @if (personalApps.length > 0) {
        <div class="rail__divider" aria-hidden="true"></div>
        <div class="rail__section rail__section--personal">
          @for (app of personalApps; track app.id) {
            <ec-rail-item [app]="app" />
          }
        </div>
      }
    </div>

    <button
      class="rail__fade rail__fade--down"
      [class.rail__fade--visible]="canScrollDown"
      (click)="scrollDown()"
      aria-label="Scroll down"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M19 9l-7 7-7-7"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>

  <!-- Spacer: absorbs remaining height so footer stays pinned at bottom -->
  <div class="rail__spacer" aria-hidden="true"></div>

  <!-- Pinned bottom links -->
  <a
    class="rail__integrations"
    routerLink="/eciso/integration-marketplace"
    routerLinkActive="active"
    [class.active]="isIntegrationActive()"
    aria-label="Integrations"
  >
    <span class="rail__accent" aria-hidden="true"></span>
    <img
      src="./assets/app-icons/integrations-hub.svg"
      alt=""
      width="22"
      height="22"
    />
    <span>Integration Hub</span>
  </a>
  <a
    class="rail__notifications cursor-pointer"
    routerLink="/eciso/notifications"
    routerLinkActive="active"
    [class.active]="isNotificationActive()"
    aria-label="Notification"
  >
    <span class="rail__accent" aria-hidden="true"></span>
    <div class="rail__icon-wrap">
      <img src="assets/icons/ui/bell.svg" alt="" width="22" height="22" />
      @if (unreadNotifs > 0) {
        <span class="rail__badge">{{ unreadNotifs > 99 ? '99+' : unreadNotifs }}</span>
      }
    </div>
    <span class="rail__label">Notification</span>
  </a>
  <a
    class="rail__settings cursor-pointer"
    (click)="openSettings($event)"
    [class.active]="isSettingsActive()"
    aria-label="Settings"
  >
    <span class="rail__accent" aria-hidden="true"></span>
    <img src="assets/icons/ui/settings.svg" alt="" width="22" height="22" />
    <span>Settings</span>
  </a>
</nav>
